export default "__VITE_ASSET__CSUpA04k__"